import { ORGS_BASE_URL, PROJECTS_PAGE_ID } from '_/common/routes/routes.constants';
import { IOrgRouteParams, IProjectRouteParams } from '_/common/routes/routes.types';

export const getProjectsBaseUrl = ({ orgSlug }: IOrgRouteParams): string => `${ORGS_BASE_URL}/${orgSlug}/${PROJECTS_PAGE_ID}`;

export const getProjectUrl = (params: IProjectRouteParams): string => {
  const { projectSlug } = params;
  return `${getProjectsBaseUrl(params)}/${projectSlug}`;
};
